
export default {
  data() {
    return {
      title: "Best Way Guarantee | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
